/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {TractorBeamServerDataParser} from "../TractorBeamServerDataParser";

export class TractorBeamParsedGameData extends SpinParsedGameData {
    private readonly _scatterSymbolWin:number;
    private readonly _totalBetLineWins:number;
    private readonly _totalSpinWinnings:number;
    private readonly _randomFeatureTriggered:boolean;
    private readonly _removedSymbols:string[];
    private readonly _numberOfExtraFreespinsAwarded:number;
    private readonly _scatterExtraSpinPositions:number[];

    private readonly _randomStackedOverlayReels:boolean [];
    private readonly _randomStackedTriggered:boolean;

    constructor(rawData:any, dataParser:TractorBeamServerDataParser) {
        super(rawData, dataParser);
        this._scatterSymbolWin = dataParser.scatterSymbolWin(rawData);
        this._totalBetLineWins = dataParser.totalBetLineWins(rawData);
        this._totalSpinWinnings = dataParser.totalSpinWinnings(rawData);
        this._randomFeatureTriggered = dataParser.randomFeature(rawData);
        this._removedSymbols = dataParser.removedSymbols(rawData);
        this._numberOfExtraFreespinsAwarded = dataParser.numberOfExtraFreespinsAwarded(rawData);
        this._scatterExtraSpinPositions = dataParser.scatterExtraSpinPositions(rawData);

        // Random Stack Members
        this._randomStackedOverlayReels = rawData.randomStackedOverlayReels;
        this._randomStackedTriggered = rawData.randomStackedTriggered;

    }

    public get scatterSymbolWin():number {
        return this._scatterSymbolWin;
    }

    public get isRandomFeature():boolean {
        return this._randomFeatureTriggered;
    }

    public get removedSymbols():string[] {
        return this._removedSymbols;
    }

    public get numberOfExtraFreespinsAwarded():number {
        return this._numberOfExtraFreespinsAwarded;
    }

    public get scatterExtraSpinPositions():number[] {
        return this._scatterExtraSpinPositions;
    }

    public get randomStackedOverlayReels():boolean [] {
        return this._randomStackedOverlayReels;
    }

    public get randomStackedTriggered():boolean {
        return this._randomStackedTriggered;
    }
}
